import { createFileRoute } from '@tanstack/react-router';

import {
  CustomersPage,
  validateCustomersSearch,
} from '../../features/customers';

export const Route = createFileRoute('/_app/customers')({
  staticData: { crumbs: ['Клиенты'] },
  validateSearch: validateCustomersSearch,
  component: CustomersPage,
});
